






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MentoringTimeMeeting extends Vue {
  @Prop({ type: String, default: '' })
  readonly time!: string;

  @Prop({ type: String, default: '' })
  readonly address!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/timeandaddress/MentoringTimeMeeting.vue